<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @ok="handleOk" @cancel="handleCancel" cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form>
        <form-base-modal v-if="formType === 'BASE'" :model="model"></form-base-modal>
        <form-extend-modal v-if="formType === 'EXTEND'" :model="modelExtend"></form-extend-modal>
        <form-annex-modal v-if="formType === 'ANNEX'" :model="modelAnnex" :modelFileList="modelFileList" :formid="model.id" @unloadFile="loadFile"></form-annex-modal>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import FormBaseModal from '@views/tempconfig/modules/formmodal/FormBaseModal'
import FormExtendModal from '@views/tempconfig/modules/formmodal/FormExtendModal'
import FormAnnexModal from '@views/tempconfig/modules/formmodal/FormAnnexModal'
import { httpAction, getAction, postAction } from '@/api/manage'
export default {
  name: "CsimConfigFormModal",
  components: { FormBaseModal, FormExtendModal, FormAnnexModal },
  data() {
    return {
      title: "操作",
      formType: "",
      model: {},
      modelExtend: {},
      modelAnnex: {},
      modelFileList: { fileList: [] },
      customActiveKey: '1',
      visible: false,
      confirmLoading: false,
      url: {
        add: "/tempconfig/tempConfigForm/add",
        edit: "/tempconfig/tempConfigForm/edit",
        fileList: '/tempconfig/tempConfigFormFile/listAll',
      },
    }
  },

  props: {
    selectForm: {
      type: Object,
      required: true
    },
  },

  methods: {
    add() {
      this.edit({
        scale: '0',
        keywordList: [],
      });
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
      this.model = Object.assign({
        keywordList: record.keyword ? record.keyword.split(',') : []
      }, record);

      if (this.model.extend) {
        this.modelExtend = JSON.parse(this.model.extend);
      } else {
        this.modelExtend = {}
      }
      if (this.model.annex) {
        this.modelAnnex = JSON.parse(this.model.annex);
      } else {
        this.modelAnnex = {}
      }
      this.loadFile()      
    },
    loadFile(){
      getAction(this.url.fileList, { 'formId': this.model.id, 'type': 1 }).then(res => {
        if (res.success && res.result) {
          const fileListtemp = []
          res.result.forEach(file => {
            fileListtemp.push(file)
          })
          this.modelFileList.fileList = fileListtemp
        } else {
          this.modelFileList.fileList = []
        }
      })
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      let isValid = true; // 默认验证
      // // 触发表单验证
      if (isValid) {
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        if (!this.model.id) {
          httpurl += this.url.add;
          method = 'post';
        } else {
          httpurl += this.url.edit;
          method = 'put';
        }
        let addFile = false
        this.modelFileList.fileList.forEach((file, index) => {
          if (file.id == "") {
            const params = {
              formId: this.model.id,
              path: file.response.message,
              name: file.name,
              size: file.size,
              suffix: file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length),
              type: 1
            }
            addFile = true
            postAction('/tempconfig/tempConfigFormFile/add', params).then(res => {
              if (res.success) {
                console.log('OK')
              } else {
                that.$message.warning(res.message);
              }
            })
          }
        })
        let formData = JSON.parse(JSON.stringify(this.model));
        formData.extend = JSON.stringify(this.modelExtend)
        formData.annex = JSON.stringify(this.modelAnnex)
        if(addFile){
          formData.status = formData.status | 8
        }
        httpAction(httpurl, formData, method).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            // that.$emit('ok');
            that.close();
          } else {
            that.$message.warning(res.message);
          }

          that.$emit("reloadFormList");
          that.$emit("reloadSelectForm");
        }).finally(() => {
          that.confirmLoading = false;
        })
      } else {
        return false;
      }
    },
    handleCancel() {
      this.close()
    },
  }
}
</script>

<style lang="less" scoped></style>